import axios from "axios"
import Swal from "sweetalert2"
const state = {
  STATUS: null,
  API_ROUTE: "/lookup/lookupmaster",
  lookup: []
}

const getters = {}

const mutations = {}

const actions = {
  async updateUserStatus({ commit }, { payload, userType }) {
    const { userId, status } = payload
    let statusText = status == 2 ? "Activate" : "Deactivate"
    const confirm = await Swal.fire({
      title: `${statusText} User?`,
      text: `Are you sure you want to ${statusText.toLowerCase()} this user?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    })
 
    if (confirm.dismiss) return
    const url = `${process.env.VUE_APP_URL}/mgmt-users/${userType}`
    const config = {
      headers: {
        "Content-Type": "application/json"
      }
    }
    try {
      const response = await window.axios.patch(url, { userId, status }, config)
      Swal.fire({
        title: "Success",
        text: `User has been ${statusText.toLowerCase()}d successfully.`,
        icon: "success"
      })
      return response
    } catch (error) {
      throw error
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
